export enum SubscriptionPlanIntervalEnum {
  Day = 'day',
  Week = 'week',
  Month = 'month',
  Year = 'year',
}
